import React from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiArrowUpLeft } from "react-icons/fi";
import styles from "./Styles/DesktopLanding.module.css";
import CampaignCarousel from "./CampaignCarousel";
import LatestGallery from "./LatestGallery";
import DesktopSlideshow from "./DesktopSlideshow";
import DesktopBottomBanners from "./DesktopBottomBanners";

const logo = `${process.env.PUBLIC_URL}/logo192-transparent.png`;

export default function DesktopLanding() {
  return (
    <div className={styles.landing} dir="rtl">
      <a className={styles.skipLink} href="#featured">رفتن به محتوای اصلی</a>
      <div className={styles.navbarBackground}>
      <header className={styles.header}>
        <Link to="/" className={styles.brand} aria-label="راه بهشت، خانه"><span className={styles.brandMark}><img src={logo} alt="راه بهشت" /></span><span>راه بهشت<small>سامانه ارتباطات فرهنگی خانواده گروه فولاد مبارکه</small></span></Link>
        <nav aria-label="ناوبری اصلی" className={styles.navigation}>
          <a href="/pointshop">ویترین جوایز</a><a href="/gallery">گزارش تصویری</a><Link to="/blog">مجله و اخبار</Link><a href="https://eitaa.com/msc_cul" target="_blank" rel="noreferrer">فرهنگ و خانواده در ایتا</a><a href="/contractingStores">مراکز طرف قرارداد</a>
        </nav>
        <Link className={styles.headerAction} to="/dashboard">پیشخوان راه بهشت <FiArrowUpLeft aria-hidden="true" /></Link>
      </header>
      </div>

      <DesktopSlideshow />

      <DesktopBottomBanners />

      <section id="featured" className={styles.featured} aria-labelledby="featured-title">
        <div className={styles.sectionHeading}><div><span className={styles.sectionLabel}>از دنیای راه بهشت</span><h2 id="featured-title">روایت‌ها و برنامه‌های خانواده ما</h2></div><Link className={styles.textButton} to="/archive">همه پرونده‌ها <FiArrowLeft aria-hidden="true" /></Link></div>
        <CampaignCarousel />
      </section>

      <LatestGallery />

      <footer className={styles.footerShell}>
        <div className={styles.footer}>
          <div className={styles.footerTop}>
            <div className={styles.footerIntro}>
              <Link to="/" aria-label="راه بهشت، خانه"><img src={logo} alt="راه بهشت" className={styles.footerLogo} /></Link>
              <p className={styles.footerTagline}>همراه در فرهنگ، همدل در زندگی</p>
              <p>سامانه ارتباطات فرهنگی خانواده گروه فولاد مبارکه؛ خانه‌ای برای دنبال کردن برنامه‌ها، خواندن روایت‌ها و ساختن تجربه‌های مشترک.</p>
              <a className={styles.footerSocial} href="https://eitaa.com/msc_cul">فرهنگ و خانواده در ایتا <FiArrowUpLeft aria-hidden="true" /></a>
            </div>
            <nav className={styles.footerColumn} aria-labelledby="footer-explore">
              <h3 id="footer-explore">کشف راه بهشت</h3>
              <Link to="/archive">آرشیو برنامه‌ها</Link>
              <Link to="/gallery">گزارش‌های تصویری</Link>
              <Link to="/blog">اخبار و تازه‌ها</Link>
            </nav>
            <nav className={styles.footerColumn} aria-labelledby="footer-family">
              <h3 id="footer-family">برای خانواده</h3>
              <Link to="/archive?filter=هم‌خانواده">نشریه هم‌خانواده</Link>
              <Link to="/roshana">حلقه‌های کتاب روشنا</Link>
              <Link to="/archive?filter=پویش">پویش‌های خانواده</Link>
              <a href="https://lib.msc.ir">کتابخانه ارغوان</a>
            </nav>
            <div className={styles.footerColumn}>
              <h3>کنار شما هستیم</h3>
              <p>برای پرسش‌ها و پیگیری درخواست‌ها، با پشتیبانی راه بهشت در ارتباط باشید.</p>
              <a className={styles.footerSupport} href="https://eitaa.com/msc_cul_admin">گفت‌وگو با پشتیبانی <FiArrowUpLeft aria-hidden="true" /></a>
              <Link to="/createTicket">ثبت درخواست پشتیبانی</Link>
            </div>
          </div>
          <div className={styles.footerBottom}><span>تمام حقوق این وب‌سایت متعلق به «مدیریت ارتباطات و برند سازمانی گروه فولاد مبارکه» است.</span><span>رویین سافت © {new Date().toLocaleDateString("fa-IR-u-ca-persian", { year: "numeric" })}</span></div>
        </div>
      </footer>
    </div>
  );
}
